import * as React from "react";

export interface ContentContainerProps {
  className: string;
  style: React.CSSProperties;
  children?: any;
}

export default (props: ContentContainerProps) => (
  <div id="wsc_body_content_container" className={props.className} style={props.style}>
    {props.children}
  </div>
);
